import styled, { css } from "styled-components";
import { color, units, variant } from "@m/alchemy-theme";
import { LabelWrapper } from "../field-label/FieldLabel.styled";
import { Input, InputWrapper } from "../input/Input.styled";
import { TextArea, TextAreaWrapper } from "../text-area/TextArea.styled";
export const sizeMap = {
    small: {
        adornmentWidth: 32,
        adornmentSize: 16,
        verticalPadding: 8,
        inputHeight: 28,
        fontSize: 14
    },
    default: {
        adornmentWidth: 36,
        adornmentSize: 16,
        verticalPadding: 8,
        inputHeight: 32,
        fontSize: 14
    },
    medium: {
        adornmentWidth: 40,
        adornmentSize: 16,
        verticalPadding: 8,
        inputHeight: 36,
        fontSize: 16
    },
    large: {
        adornmentWidth: 56,
        adornmentSize: 24,
        verticalPadding: 8,
        inputHeight: 44,
        fontSize: 18
    }
};
export const Wrapper = styled.div `
  position: relative;
  color: ${color("typeBody")};
  --font-size: ${({ sizeVariant }) => sizeMap[sizeVariant || "default"].fontSize}px;
  --input-height: ${({ sizeVariant }) => sizeMap[sizeVariant || "default"].inputHeight}px;

  ${({ isFullWidth }) => isFullWidth &&
    css `
      width: 100%;

      ${Input},
      ${InputWrapper},
      ${TextArea},
      ${TextAreaWrapper} {
        width: 100%;
      }
    `}

  &::after {
    clear: both;
    overflow: hidden;
  }

  ${variant("layoutVariant", {
    stacked: css `
      ${LabelWrapper} {
        margin-bottom: ${units(0.5)};
      }
    `,
    inline: css `
      align-items: flex-start;
      display: flex;

      ${LabelWrapper} {
        padding-top: ${units(1)};
        padding-right: ${units(1)};
      }
    `
})};
`;
